import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LAYER } from 'js/components/common/PopupManager';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useShowTermsPopup = () => {
    const dispatch = useDispatch();

    return useCallback((event: React.MouseEvent<HTMLElement>, termAndConditionWebContentId: string, title: string): void => {
        event.preventDefault();

        dispatch(showCommonPopupAction({
            layer: LAYER.BONUS,
            title,
            articleId: termAndConditionWebContentId
        }));
    }, [dispatch]);
};
